import React from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Box, Button, Typography } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import SummaryTable from './tableReport/SummaryTable'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { CSVLink } from 'react-csv'
import { useEffect } from 'react'
import * as id from '../common/AcountingId'
import { focusElemnt, navigation3 } from '../../../common/helper'

const BTwoCReport = (props) => {
    const { filterData, loginData, tableData, isPdfLoading, setIsPdfLoading } = props
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const [reportData, setReportData] = useState([])
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        if (tableData.length) {
            let newData = tableData.map((obj) => ({ ...obj, isRowData: true }))
            setReportData(newData)
        } else {
            setReportData([{ isNoData: true, caption: 'No Records', colSpan: 6 }])
        }
    }, [tableData])
    const columnSummaryDefs = [
        { headerName: 'State As Per GSTN No', exportHead: 'State As Per GSTN No', field: 'StateAsPerGSTNNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '174px', textAlign: 'left' } },
        { headerName: 'Rate', exportHead: 'Rate', field: 'Rate', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '175px', textAlign: 'right' } },
        { headerName: 'Taxable Value', exportHead: 'Taxable Value', field: 'TaxableValue', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '174px', textAlign: 'right' } },
        { headerName: 'IGST', exportHead: 'IGST', field: 'IGST', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '175px', textAlign: 'right' } },
        { headerName: 'CGST', exportHead: 'CGST', field: 'CGST', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '133px', textAlign: 'right' } },
        { headerName: 'SGST', exportHead: 'SGST', field: 'SGST', xlCol: { dataType: 'currency', dataFormatter: null }, headerSx: { minWidth: '134px', textAlign: 'right' } },
    ]
    const printReport = (isSave = false) => {
        setState({ ...state, load: true, generatePDF: true })
        setIsPdfLoading(true);
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
        const doc = new jsPDF({ orientation: 'p', format: [1156, 1636], unit: 'px', compress: true })
        doc.setProperties({
            title: `GST B2C Summary.pdf`,
            subject: 'GST B2C Summary Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system,GST B2C Summary',
            creator: 'MTLPL',
        })
        const HeaderColumns = filterData.includeBranches ?
            [
                { header: 'Report View', dataKey: 'reportViewName', xlCol: { dataType: 'string' } },
                { header: 'Report Type', dataKey: 'reportTypeName', xlCol: { dataType: 'string' } },
                { header: 'State', dataKey: 'state', xlCol: { dataType: 'string' } },
                { header: 'GSTIN', dataKey: 'GSTOpt', xlCol: { dataType: 'string' } },
                { header: 'Branches', dataKey: 'branch', xlCol: { dataType: 'string' } },
            ] : [
                { header: 'Report View', dataKey: 'reportViewName', xlCol: { dataType: 'string' } },
                { header: 'Report Type', dataKey: 'reportTypeName', xlCol: { dataType: 'string' } },
                { header: 'State', dataKey: 'state', xlCol: { dataType: 'string' } },
            ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: [filterData],
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                fontStyle: 'normal',
                font: "Roboto",
                lineWidth: 0.6,
            },
            columnStyles: filterData.includeBranches ? {
                0: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 195, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                1: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 195, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                2: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 195, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                3: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 195, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                4: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 195, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },

            } :
                {
                    0: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 325, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                    1: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 325, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                    2: { textColor: [0, 0, 0], fontSize: 18, cellPadding: 12, minCellHeight: 36, minCellWidth: 325, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                }
            ,
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                doc.text(`Date:${filterData.FromDate} to ${filterData.ToDate}`, data.settings.margin.left, 150)
                doc.text(`${filterData.includeBranches ? `Report:GST B2C (Includes Branches Having GSTIN)` : 'Report:GST B2C '}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
            },
            showHead: "firstPage",
        })
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(16)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        let drawCell = function (data) {
            var rows = data.table.body
            if (data.row.section === 'head') {
                if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                    data.cell.styles.halign = "right";
                } else {
                    data.cell.styles.halign = "left";
                }
            }
            rows.map((val) => {
                if (val.raw.isNoData) {
                    val.cells[0].text = val.raw.caption.toString();
                    val.cells[0].colSpan = val.raw.colSpan;
                    val.cells[0].styles.halign = 'center'
                }
            })
        }
        let pdfColumns = columnSummaryDefs.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        autoTable(doc, {
            margin: { top: 100, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfColumns,
            tableLineWidth: 0.6,
            body: reportData,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: {
                0: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 176, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'left' },
                1: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 177, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                2: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 176, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                3: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 177, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                4: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 134, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
                5: { fontSize: 16, textColor: [0, 0, 0], minCellWidth: 136, font: 'Roboto', fontStyle: "normal", valign: 'middle', minCellHeight: 36, cellPadding: 6, halign: 'right' },
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                cellPadding: 6,
                fontSize: 16,
                minCellHeight: 36,
                valign: 'middle',
                font: 'Roboto',
                fontStyle: 'normal',
            },
            didParseCell: (data) => {
                drawCell(data)
            },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 30, 50, 50)
                doc.setFontSize(26).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | GST Return Report', 30 + 60, 60)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`GST B2C Summary ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('output').data = pdfUrl
            // document.getElementById('output').data = doc.output('datauristring', 'GST B2C Summary.pdf')
            focusElemnt('backBtn')
        }, 2000)

    }
    const backToScreenView = () => {
        setIsPdfLoading(false)
        const data = document.getElementById('output')
        data.innerHTML = ''
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                    Report For: GST B2C Summary
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="reportButtons">
                    {!isPdfLoading ?
                        <>
                            <Item sx={sx.itemsx} className="disabled-wrapper"
                                onKeyDown={(e) => {
                                    navigation3(e, "csvfileBtn", id.reportmainButton, () => { })
                                }}
                            >
                                <ReactHtmlTableToExcel
                                    id="exportExcelBtn"
                                    className="receiveitemExcelBtn"
                                    table="BTwoCReport"
                                    filename={`B2C Summary Report ${currentDateTime}`}
                                    sheet="tablexls"
                                    buttonText="Export to Excel"
                                />
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper"
                                onKeyDown={(e) => {
                                    navigation3(e, "exportPdf", "exportExcelBtn", () => { document.getElementById("csvfileBtn").click() })
                                }}
                            >
                                <CSVLink filename='B2C Summary.csv' id={"csvfileBtn"} className="receiveitembtn exportCSVBtn" data={reportData} headers={columnSummaryDefs.map((val) => ({ label: val.exportHead, key: val.field }))}>
                                    Export As CSV
                                </CSVLink>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" sx={{ width: '100%' }} id={"exportPdf"} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, "printBtn", "csvfileBtn", () => printReport(true))
                                    }}
                                    onClick={() => {
                                        printReport(true)
                                    }}>
                                    Export As PDF
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" sx={{ width: '100%' }} id={"printBtn"} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, id.fromDate, "exportPdf", () => printReport())
                                    }}
                                    onClick={() => {
                                        printReport()
                                    }}>
                                    Print
                                </Button>
                            </Item>
                        </>
                        :
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="outlined" id={"backBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                onKeyDown={(e) => {
                                    navigation3(e, id.fromDate, id.reportmainButton, () => {
                                        backToScreenView()
                                        focusElemnt(id.reportmainButton)
                                    })
                                }}
                                onClick={backToScreenView}>
                                Back
                            </Button>
                        </Item>
                    }
                </Box>
            </Box>
            {!isPdfLoading ?
                <Box sx={sx.reportFlex}>
                    <SummaryTable columnSummaryDefs={columnSummaryDefs} reportData={reportData} id={"BTwoCReport"} />
                </Box>
                :
                <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                    {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {state.load ? (
                        <object
                            id="output"
                            type="application/pdf"
                            width="100%"
                            height="440"
                            title="MTLPL -Cargo System - LR Wise Detailed Status"
                            aria-label="MTLPL -Cargo System - LR Wise Detailed Status"
                        ></object>
                    ) : (
                        ''
                    )}
                </Box>
            }
        </>
    )
}

export default BTwoCReport